module.exports = __webpack_public_path__ + "static/media/cross-device-mockup-16x10-desktop@2x.dab46593.png";